import { render, staticRenderFns } from "./AddCustomForm.vue?vue&type=template&id=9e6dab2e&scoped=true"
import script from "./AddCustomForm.vue?vue&type=script&lang=js"
export * from "./AddCustomForm.vue?vue&type=script&lang=js"
import style0 from "./AddCustomForm.vue?vue&type=style&index=0&id=9e6dab2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6dab2e",
  null
  
)

export default component.exports